import React from "react";

import { MoreVertical } from "react-feather";

const Dropdown = props => {
  const { classes, icon, bttnSize } = props;

  return (
    <div className="dropdown">
      <button className={`dropdown__btn rounded__btn ml-10 ${classes}`.trim()} style={{ width: bttnSize + "px", height: bttnSize + "px"  }}>
        {icon}
      </button>
      <ul className="dropdown__nav">
        {props.children}
      </ul>
    </div>
  );
}

Dropdown.defaultProps = {
  icon: <MoreVertical />
}

export default Dropdown;